// 如果一周的开始日期为星期天则为0，如果一周开始是星期一则为1
let weekStartFlag = 1;

let now = null; // 当前时间
let nowYear = null; //当前年
let nowMonth = null; //当前月
let nowDay = null; //当前日
let nowDayOfWeek = null; //今天本周的第几天

function init() {
  now = new Date();
  nowYear = now.getFullYear();
  nowMonth = now.getMonth();
  nowDay = now.getDate();
  nowDayOfWeek = now.getDay();
}

//获得某月的天数
function getMonthDays(myMonth) {
  let monthStartDate = new Date(nowYear, myMonth, 1);
  let monthEndDate = new Date(nowYear, myMonth + 1, 1);
  let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}

//获得本季度的开始月份
function getQuarterStartMonth() {
  let quarterStartMonth = 0;
  if (nowMonth < 3) {
    quarterStartMonth = 0;
  }
  if (2 < nowMonth && nowMonth < 6) {
    quarterStartMonth = 3;
  }
  if (5 < nowMonth && nowMonth < 9) {
    quarterStartMonth = 6;
  }
  if (nowMonth > 8) {
    quarterStartMonth = 9;
  }
  return quarterStartMonth;
}

let past = [
  {
    text: '今天',
    start: () => {
      return new Date();
    },
    end: () => {
      return new Date();
    },
  },
  {
    text: '昨天',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - 1);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - 1);
    },
  },
  {
    text: '本周',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + weekStartFlag);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek + weekStartFlag));
    },
  },
  {
    text: '上周',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + weekStartFlag - 7);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + weekStartFlag - 1);
    },
  },
  {
    text: '近7天',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - 6);
    },
    end: () => {
      return new Date();
    },
  },
  {
    text: '本月',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, 1);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    },
  },
  {
    text: '上月',
    start: () => {
      init();
      let month = nowMonth - 1;
      return new Date(nowYear, month, 1);
    },
    end: () => {
      init();
      let month = nowMonth - 1;
      return new Date(nowYear, month, getMonthDays(month));
    },
  },
  {
    text: '近30天',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - 29);
    },
    end: () => {
      return new Date();
    },
  },
  {
    text: '本季度',
    start: () => {
      init();
      return new Date(nowYear, getQuarterStartMonth(), 1);
    },
    end: () => {
      init();
      var quarterEndMonth = getQuarterStartMonth() + 2;
      return new Date(nowYear, quarterEndMonth, getMonthDays(quarterEndMonth));
    },
  },
  {
    text: '上季度',
    start: () => {
      init();
      let startMonth = getQuarterStartMonth() - 3;
      return new Date(nowYear, startMonth, 1);
    },
    end: () => {
      init();
      let endMonth = getQuarterStartMonth() - 3 + 2;
      return new Date(nowYear, endMonth, getMonthDays(endMonth));
    },
  },
  {
    text: '近3个月',
    start: () => {
      init();
      let month = nowMonth - 2;
      return new Date(nowYear, month, 1);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    },
  },
  {
    text: '近6个月',
    start: () => {
      init();
      let month = nowMonth - 5;
      return new Date(nowYear, month, 1);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    },
  },
  
];

let future = [
  {
    text: '今天',
    start: () => {
      return new Date();
    },
    end: () => {
      return new Date();
    },
  },
  {
    text: '明天',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay + 1);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay + 1);
    },
  },
  {
    text: '本周',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + weekStartFlag);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek + weekStartFlag));
    },
  },
  {
    text: '下周',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + weekStartFlag + 7);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + weekStartFlag + 13);
    },
  },
  {
    text: '未来7天',
    start: () => {
      return new Date();
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay + 6);
    },
  },
  {
    text: '本月',
    start: () => {
      init();
      return new Date(nowYear, nowMonth, 1);
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    },
  },
  {
    text: '下月',
    start: () => {
      init();
      let month = nowMonth + 1;
      return new Date(nowYear, month, 1);
    },
    end: () => {
      init();
      let month = nowMonth + 1;
      return new Date(nowYear, month, getMonthDays(month));
    },
  },
  {
    text: '未来30天',
    start: () => {
      return new Date();
    },
    end: () => {
      init();
      return new Date(nowYear, nowMonth, nowDay + 29);
    },
  },
  {
    text: '本季度',
    start: () => {
      init();
      return new Date(nowYear, getQuarterStartMonth(), 1);
    },
    end: () => {
      init();
      var quarterEndMonth = getQuarterStartMonth() + 2;
      return new Date(nowYear, quarterEndMonth, getMonthDays(quarterEndMonth));
    },
  },
  {
    text: '下季度',
    start: () => {
      init();
      let startMonth = getQuarterStartMonth() + 3;
      return new Date(nowYear, startMonth, 1);
    },
    end: () => {
      init();
      let endMonth = getQuarterStartMonth() + 3 + 2;
      return new Date(nowYear, endMonth, getMonthDays(endMonth));
    },
  },
  {
    text: '未来3个月',
    start: () => {
      init();
      let month = nowMonth + 1;
      return new Date(nowYear, month, 1);
    },
    end: () => {
      init();
      let month = nowMonth + 3;
      return new Date(nowYear, month, getMonthDays(month));
    },
  },
  {
    text: '未来6个月',
    start: () => {
      init();
      let month = nowMonth + 1;
      return new Date(nowYear, month, 1);
    },
    end: () => {
      init();
      let month = nowMonth + 6;
      return new Date(nowYear, month, getMonthDays(month));
    },
  },  
];

export default {
  past,
  future,
  extraFuture: [...future, {
      text: '昨天及以前',
      start: () => {
        init();
        return new Date(2020, 1, 1);
      },
      end: ()=> {
        init();
        return new Date(nowYear, nowMonth, nowDay - 1);
      }
    
  }]
};
